import firebase from 'firebase';

const config = firebase.initializeApp({
    apiKey: "AIzaSyCmdn7JTODKMPqGGlOiEnXQTLbyaI65778",
    authDomain: "bib15app.firebaseapp.com",
    databaseURL: "https://bib15app-default-rtdb.firebaseio.com",
    projectId: "bib15app",
    storageBucket: "bib15app.appspot.com",
    messagingSenderId: "548667575686",
    appId: "1:548667575686:web:aceba5d88fb0ee7e897007",
    measurementId: "G-0GC7JT5FKQ"
  });
  
const db=firebase.firestore();

export {db}
export default !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();